
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/line",
      function () {
        return require("private-next-pages/line/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/line"])
      });
    }
  